import React from "react";
import { Box, Divider } from "@mui/material";

const PageBreak = () => {
  return (
    <Box
      sx={{
        width: "100%",
      }}
      className="hide-on-print"
    >
      <Divider
        sx={{
          borderBottomWidth: "40px", // Makes the divider line thicker
          borderColor: "#CCCCCC",
          mx: -2,
        }}
      />
    </Box>
  );
};

export default PageBreak;
